const reviewFormClasses = {
  form: 'flex flex-col mt-8 sm:w-3/4 md:w-3/4 mx-auto',
  section: 'flex flex-col mb-4',
  label: 'font-semibold text-lg mb-2',
  input: 'border p-2 bg-slate-800 border-slate-700',
  error: 'text-red-500 text-center',
  button:
    'text-white font-semibold text-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg px-5 py-2.5 text-center mr-3 md:mr-0',
}

export default reviewFormClasses
